<!--婴幼儿管理-->
<template>
  <div class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="140px">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="queryParam.searchDay"
              type="daterange"
              range-separator=""
              start-placeholder="开始"
              value-format="yyyy-MM-dd"
              end-placeholder="结束">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div></div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                style="width: 100%"
                :data="tableData"
                max-height="540"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="phoneNumber" label="手机号" width="180"></el-table-column>
        <el-table-column prop="childName" label="会员姓名"></el-table-column>
        <el-table-column prop="childGender" label="孩子性别"></el-table-column>
        <el-table-column prop="childPetName" label="小名"></el-table-column>
        <el-table-column prop="childType" label="类型"></el-table-column>
        <el-table-column prop="childBirthday" label="孩子生日"></el-table-column>
        <el-table-column prop="childMonth" label="孩子月龄"></el-table-column>
        <el-table-column prop="areaAddress" label="社区详细地址"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>

  import globaldata from "../../../utils/globaldata";
  import {queryBdChildBirthdayArrived} from "../../../api/bd/BaseData";
  import commonUtils from "../../../utils/commonUtils";
  import {EChildGender} from "../../../utils/enumsUtil";
  import enumsUtil from "../../../utils/enumsUtil";
  import {formatDate} from "../../../utils/date";

  export default {
    components: {},
    data() {
      return {
        listLoading: true,
        queryParam:{
          searchDay:[],

          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },



        //表单结果
        tableData: [
        ],

      }
    },
    created(){

      this.intiData();
      this.flechList();

    },
    mounted() {
    },
    methods: {

      intiData(){
        let nowDate = formatDate(new  Date(),"yyyy-MM-dd");
        this.queryParam.searchDay.push(nowDate);
        this.queryParam.searchDay.push(nowDate)
      },
      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },
      flechList(){
        this.listLoading = true;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          lessonTemplateId:enumsUtil.lessonTemplateIdBS(),
          startDay:this.queryParam.searchDay[0],
          endDay:this.queryParam.searchDay[1],
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }
        queryBdChildBirthdayArrived(param).then(response =>
        {
          this.listLoading = false;
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);

        })
      },
      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
        let tableDataList = [];
        for (let i = 0;i< list.length;++i){


          let genderDes =  EChildGender(list[i].gender);

          let childType = enumsUtil.childBodyType(list[i].childType);


          let data = {
            number : i+1 ,
            id: list[i].id,
            userId:list[i].userId,
            userName:list[i].userName,
            phoneNumber:list[i].userPhone,
            childName :list[i].name,
            gender:list[i].gender,
            childGender : genderDes,
            childPetName :list[i].petName,
            childBirthday : list[i].birthday,
            areaAddress: list[i].areaAddress,
            childMonth:list[i].childMonth,
            childType:childType
          };
          tableDataList.push(data);
        }
        this.tableData = tableDataList;
      },
      handleSizeChange(val) {
        this.queryParam.pageNum = 1;
        this.queryParam.pageSize = val;
        this.flechList();
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/base-data/bd-child-birthday-arrived/indexBs.vue